<ng-container *transloco="let t">
  <IDataTable class="min-h-0 flex-1" [datasource]="dataSource">
    <table iTable class="w-full">
      <thead iTableHead>
        <tr>
          <th iTableTh></th>
          <th iTableTh>{{ t("common.account") }}</th>
          <th iTableTh>{{ t("common.marketplaces") }}</th>
          <th iTableTh></th>
        </tr>
      </thead>
      <tbody>
        @for (resource of dataSource.data(); track resource.profileId) {
          <tr iTableRow>
            <td iTableTd>
              <div>
                <ICheckbox
                  [value]="isSelected(resource)"
                  (valueChange)="select(resource)"
                  [disabled]="!isSelectable(resource)"
                />
              </div>
            </td>
            <td iTableTd>{{ resource.accountName }}</td>
            <td iTableTd><IBadge [label]="resource.marketplace" size="xs" /></td>
            <td iTableTd>
              @if (resource.state === BidderOn) {
                <div>{{ t("billing-account-selection.this_account_is_part_of_your_current_plan") }}</div>
              }
              @if (alreadyUsedByAnotherOrganization()?.has(resource)) {
                <div class="text-destructive text-sm">
                  {{ t("billing-account-selection.accountanother_org_error") }}
                </div>
              }
              @if (!resource.activated) {
                <div class="text-destructive text-sm" [innerHTML]="activationMessage"></div>
              }
              @if (!resource.hasAccessToAdvertising) {
                <div class="text-destructive text-sm">{{ t("billing-account-selection.access_lost") }}</div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </IDataTable>
  <div class="modal-footer flex justify-end gap-2">
    <button iButton variant="secondary" size="md" (click)="cancelSelection()">{{ t("common.cancel") }}</button>
    <button iButton size="md" (click)="saveSelection()" [disabled]="!isValidSelection()">
      {{ t("common.save") }}
    </button>
  </div>
</ng-container>
